import React, { Suspense } from "react";
import ReactGA from "react-ga4";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "./common.scss";
import "./dashboard.scss";
import "./customer.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-widgets/scss/styles.scss";
import AppRouters from "./AppRouters";
import { Providers } from "./redux/provider";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

const gaId = process.env.REACT_APP_GA_ID;
if (gaId) {
  ReactGA.initialize(gaId);
  ReactGA.send("pageview");
}

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <I18nextProvider i18n={i18n}>
        <Providers>
          <BrowserRouter future={{ v7_startTransition: true }}>
            <AppRouters />
          </BrowserRouter>
        </Providers>
      </I18nextProvider>
    </Suspense>
  );
}
export default App;
